<template>
  <div id="secure-dataflow-alert-summary" v-show="onAlertSummaryNotification">
    <div class="alert-summary-tab">
      <label @click="isActive = !isActive">
        <div class="flex items-center">
          <div v-if="hasAlert">
            <feather-icon
              icon="InfoIcon"
              svgClasses="h-8 w-8 sdf-text-18-400-red"
              class="mr-4"
              style="vertical-align:middle;"
            />
            <span class="sdf-text-25-400-white" style="vertical-align:middle;"
            ><span class="mr-2 sdf-text-30-400-red">{{
                count
              }}</span
            >件の異常を検知しています</span
            >
          </div>
          <div v-else>
            <feather-icon
              icon="InfoIcon"
              svgClasses="h-8 w-8 sdf-text-18-400-red"
              class="mr-4"
              style="vertical-align:middle;"
            />
            <span class="sdf-text-25-400-white" style="vertical-align:middle;"
            >異常は検知されていません</span
            >
          </div>
          <i
            style="vertical-align:baseline;"
            class="ml-8 feather icon-chevrons-up sdf-text-20-400-white"
            :class="[
              { 'rotate-icon-up': isActive },
              { 'rotate-icon-down': !isActive }
            ]"
          ></i>
        </div>
      </label>
      <vs-divider class="border-style mt-0 mb-0"/>
      <div
        class="hide-alert-summary"
        :class="[{ 'show-alert-summary': isActive }]"
      >
        <div class="alert-summary-table">
          <vs-row vs-w="12">
            <vs-col
              class="sdf-text-16-400-white mr-8 mb-4 cursor-pointer"
              vs-type="flex"
              vs-justify="flex-end"
              vs-align="center"
              vs-w="12"
            >
              <router-link
                :to="{ name: 'addon-secure-dataflow-alert-summary' }"
                custom
                v-slot="{ navigate, isActive, isExactActive }"
              >
                <div
                  class="cursor-pointer transition-menu-padding"
                  :class="[isActive && 'router-link-active', isExactActive && 'router-link-exact-active']"
                  :active="isActive"
                  @click="navigate"
                >
                  <div class="flex items-center">
                    <feather-icon
                      icon="ClipboardIcon"
                      svgClasses="h-6 w-6"
                      class="mr-4"
                    />
                    アラートサマリー一覧
                  </div>
                </div>
              </router-link>
            </vs-col>
          </vs-row>
          <div class="sdf-text-14-400-light-navy mb-4">
            <vs-row vs-w="12">
              <vs-col
                vs-type="flex"
                vs-justify="flex-start"
                vs-align="center"
                vs-w="1"
              >
              </vs-col>
              <vs-col
                vs-type="flex"
                vs-justify="flex-start"
                vs-align="center"
                vs-w="2"
              >
                発生日時
              </vs-col>
              <vs-col
                vs-type="flex"
                vs-justify="flex-start"
                vs-align="center"
                vs-w="1"
              >
                ID
              </vs-col>
              <vs-col
                vs-type="flex"
                vs-justify="flex-start"
                vs-align="center"
                vs-w="5"
              >
                アラート名
              </vs-col>
            </vs-row>
          </div>
          <VuePerfectScrollbar class="scroll-area" :settings="settings">
            <div
              class="sdf-text-18-400-red"
              v-for="(alert, key) in alertList"
              :key="key"
            >
              <vs-row vs-w="12">
                <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="1">
                  <feather-icon icon="InfoIcon" svgClasses="h-8 w-8" class="mr-4"/>
                </vs-col>
                <vs-col
                  vs-type="flex"
                  vs-justify="flex-start"
                  vs-align="center"
                  vs-w="2"
                >
                  {{displayAlertOccurTime(alert)}}
                </vs-col>
                <vs-col
                  vs-type="flex"
                  vs-justify="flex-start"
                  vs-align="center"
                  vs-w="1"
                >
                  {{ alert.channelId || "" }}
                </vs-col>
                <vs-col
                  vs-type="flex"
                  vs-justify="flex-start"
                  vs-align="center"
                  vs-w="4"
                >
                  {{ alert.channelName || "" }}
                </vs-col>
                <vs-divider class="ml-8 mr-8" :color="sdfColor.LightNavy"/>
              </vs-row>
            </div>
          </VuePerfectScrollbar>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import _ from 'lodash';

// mixins
import {
  ColorMixin,
  MappingTableMixin,
  StoreMenuMixin,
  StoreMonitoringVesselManeuveringMixin,
  StoreCommonsMixin
} from "@/mixins/addon/secure-dataflow";

import {ChannelDataUtil} from "@/utils/secure-dataflow"
import SecureDataflowService from "@/services/secureDataflowService";
import moment from "moment-timezone";
import { createNamespacedHelpers } from "vuex";
const { mapGetters, mapState, mapActions } = createNamespacedHelpers(
  "monitoringVesselEngine"
);

export default {
  name: "AlertSummary",
  mixins: [
    ColorMixin,
    MappingTableMixin,
    StoreMenuMixin,
    StoreMonitoringVesselManeuveringMixin,
    StoreCommonsMixin
  ],
  components: {VuePerfectScrollbar},
  data() {
    return {
      intervalId: null,
      isActive: false,
      lastUpdateAt: null,
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.6
      },
      beforeAlertList: [],
      alertList: [],
      alertListObj: null,

      hasCalledAlertHistory: false
    };
  },
  watch: {
    channelDataEngine: {
      handler: _.debounce(function () {
        if (this.hasChannelMaster) {
          this.crateAlertList()
        }
      }, 1500),
      deep: true
    },
    connectingState4gVSAT: {
      handler: _.debounce(function (val) {
        if (val === null) return
        if (val.isDisconnect) {
          let data = {
            id: 1,
            channelId: null,
            channelName: "4G/VSAT 両系切断",
            localTime: val.localTime.format("YYYY/MM/DD HH:mm:ss")
          };
          let index = this.alertList.findIndex((v) => v.id === 1);
          if (index !== -1) {
            this.alertList.splice(index, 1, data);
          } else {
            this.alertList.unshift(data)
          }
        } else {
          let index = this.alertList.findIndex((v) => v.id === 1);
          if (index !== -1) {
            this.alertList.splice(index, 1);
          }
        }
      }, 3000),
      deep: true
    },
    connectingStateSBX: {
      handler: _.debounce(function (val) {
        if (val === null) return
        if (val.isDisconnect) {
          let data = {
            id: 2,
            channelId: null,
            channelName: "SB-X データ不到達",
            localTime: val.localTime.format("YYYY/MM/DD HH:mm:ss")
          };
          let index = this.alertList.findIndex((v) => v.id === 2);
          if (index !== -1) {
            this.alertList.splice(index, 1, data);
          } else {
            this.alertList.unshift(data)
          }
        } else {
          let index = this.alertList.findIndex((v) => v.id === 2);
          if (index !== -1) {
            this.alertList.splice(index, 1);
          }
        }
      }, 3000),
      deep: true
    },
    connectingStateAMS: {
      handler: _.debounce(function (val) {
        if (val === null) return
        if (val.isDisconnect) {
          let data = {
            id: 3,
            channelId: null,
            channelName: "AMS データ不到達",
            localTime: val.localTime.format("YYYY/MM/DD HH:mm:ss")
          };
          let index = this.alertList.findIndex((v) => v.id === 3);
          if (index !== -1) {
            this.alertList.splice(index, 1, data);
          } else {
            this.alertList.unshift(data)
          }
        } else {
          let index = this.alertList.findIndex((v) => v.id === 3);
          if (index !== -1) {
            this.alertList.splice(index, 1);
          }
        }
      }, 3000),
      deep: true
    },
  },
  computed: {
    ...mapState({
      alertOccurTimeMap: state => state.alertOccurTimeMap
    }),
    count() {
      return this.alertList.length
    },
    hasAlert() {
      return this.alertList.length !== 0;
    },
    scrollbarTag() {
      return "VuePerfectScrollbar";
    },
    isDisconnect4gVSAT() {
      return this.connectingState4gVSAT !== null && this.connectingState4gVSAT.isDisconnect;
    },
    isDisconnectSBX() {
      return this.connectingStateSBX !== null && this.connectingStateSBX.isDisconnect;
    },
    isDisconnectAMS() {
      return this.connectingStateAMS !== null && this.connectingStateAMS.isDisconnect;
    }
  },
  methods: {
    moveTo(x) {
      this.x = x;
    },
    crateAlertList() {
      let channelDataEngine = _.cloneDeep(this.channelDataEngine)
      if (channelDataEngine) {
        let newAlertList = []
        Object.keys(channelDataEngine).forEach(k => {
          if (ChannelDataUtil.isAbnormalMachinery(channelDataEngine[k].status)) {
            let channelInfo = this.getChannelInfo(channelDataEngine[k].ch);
            if (channelInfo) {
              let data = {
                id: channelDataEngine[k].ch,
                channelId: channelInfo.channel_id,
                channelName: channelInfo.channel_name,
                localTime: moment(channelDataEngine[k].timestamp)
                  .local()
                  .format("YYYY/MM/DD HH:mm:ss")
              };

              // 最初にfirestoreからのアラートが検知できた時から5秒後に発生時間をAPIから取得
              if (!this.hasCalledAlertHistory) {
                this.prepareCallAlertHistory()
                this.hasCalledAlertHistory = true
              }
              newAlertList.push(data)
            }
          }
        })

        const disconnect_alerts = this.alertList.filter(
          (alert) =>
            (alert.id === 2 && this.isDisconnectSBX) ||
            (alert.id === 3 && this.isDisconnectAMS) ||
            (alert.id === 1 && this.isDisconnect4gVSAT)
        );
        newAlertList.splice(0, 0, ...disconnect_alerts);

        this.alertList.splice(0, this.alertList)
        this.alertList = newAlertList;

      }
    },
    displayAlertOccurTime(alert) {
      if (alert.channelId) {
        if (this.alertOccurTimeMap[alert.channelId]) {
          return this.alertOccurTimeMap[alert.channelId]
        } else {
          return "取得中"
        }
      } else {
        return alert.localTime
      }
    },
    prepareCallAlertHistory() {
      setTimeout( ()=> {
        this.$emit("initialiseAlertHistory")
      }, 5000);
    }
  }
  ,
  created() {
  }
  ,
  beforeDestroy() {
  }
}
;
</script>

<style lang="scss">
@import "src/assets/scss/secure-dataflow/monitoringVesselManeuvering/alertSummary";
</style>
